import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/domains';
import { ConversationTitle } from '../../domain';
export var GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE = 'GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE';
export var GetConversationsWithMessagesUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(GetConversationsWithMessagesUseCase, _UseCase);

  var _super = _createSuper(GetConversationsWithMessagesUseCase);

  function GetConversationsWithMessagesUseCase(conversationRepository, skillRepository, messageRepository) {
    var _this;

    _classCallCheck(this, GetConversationsWithMessagesUseCase);

    _this = _super.call(this);
    _this.conversationRepository = conversationRepository;
    _this.skillRepository = skillRepository;
    _this.messageRepository = messageRepository;
    return _this;
  }

  _createClass(GetConversationsWithMessagesUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var conversationsOrError, conversations, currentConversation, messagesPagination, messagesResult, skillsOrError, skills, defaultSkill, skillIdMap, skillId, conversationOrError, messages, nextToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.conversationRepository.getConversationsByResource(query);

              case 2:
                conversationsOrError = _context.sent;

                if (!conversationsOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Result.fail(conversationsOrError.error));

              case 5:
                conversations = conversationsOrError.getValue();

                if (!(conversations.items.length > 0)) {
                  _context.next = 16;
                  break;
                }

                currentConversation = conversations.items[0];
                _context.next = 10;
                return this.messageRepository.getMessages({
                  conversationId: currentConversation.id.toString()
                });

              case 10:
                messagesResult = _context.sent;

                if (!messagesResult.isFailure) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", Result.fail(messagesResult.error));

              case 13:
                messagesPagination = messagesResult.getValue();
                _context.next = 31;
                break;

              case 16:
                _context.next = 18;
                return this.skillRepository.getSkills({
                  limit: 100,
                  nextToken: undefined
                });

              case 18:
                skillsOrError = _context.sent;

                if (!skillsOrError.isFailure) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt("return", Result.fail(skillsOrError.error));

              case 21:
                skills = skillsOrError.getValue(); // TODO: Must get the specific skill for the resource type

                defaultSkill = skills.items[0];
                skillIdMap = {
                  createFormSkill: 'bff017f5-f2e6-4029-ade7-2450fb2ff658',
                  ieltsSkill: '517a3fe2-3aec-4093-9783-964588fbb082'
                };
                skillId = skillIdMap.createFormSkill; // const skillId = defaultSkill.id.toString();
                // Create conversation

                _context.next = 27;
                return this.conversationRepository.createConversation({
                  title: ConversationTitle["default"].value,
                  skillId: skillId,
                  context: '',
                  tags: [],
                  resourceId: query.resourceId,
                  resourceType: query.resourceType
                });

              case 27:
                conversationOrError = _context.sent;

                if (!conversationOrError.isFailure) {
                  _context.next = 30;
                  break;
                }

                return _context.abrupt("return", Result.fail(conversationOrError.error));

              case 30:
                currentConversation = conversationOrError.getValue();

              case 31:
                messages = messagesPagination ? messagesPagination.items : [];
                nextToken = messagesPagination ? messagesPagination.nextToken : undefined;
                return _context.abrupt("return", Result.ok([currentConversation, messages, nextToken]));

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return GetConversationsWithMessagesUseCase;
}(UseCase);